// removed by extract-text-webpack-plugin
module.exports = {"rewardBadgeContainer":"rewardBadgeContainer___27WmF","fadeInSlide":"fadeInSlide___2bQpw","top":"top___p-xKu","bottom":"bottom___ckbpa","inline":"inline___5IL5L","rewardChip":"rewardChip___3ZMqu","MuiChip-label":"MuiChip-label___1iGm0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/RewardBadge.module.less
// module id = 3796
// module chunks = 33